export const MEMBER_DISPLAY_CACHE_SCHEMA_VERSION = 2
export const MEMBER_DISPLAY_CACHE_PREFIX = `privana_members_display_v${MEMBER_DISPLAY_CACHE_SCHEMA_VERSION}`

function segment(value) {
  return encodeURIComponent(String(value || '').trim())
}

export function memberDisplayCacheKey({ clubCode, memberIdentity } = {}) {
  if (!clubCode || !memberIdentity) return null
  return `${MEMBER_DISPLAY_CACHE_PREFIX}:${segment(clubCode)}:${segment(memberIdentity)}`
}

export function readMemberDisplayCache(scope) {
  const key = memberDisplayCacheKey(scope)
  if (!key || typeof window === 'undefined') return null
  try {
    const cached = JSON.parse(window.localStorage?.getItem(key) || 'null')
    const exactBinding = cached?.clubCode === String(scope?.clubCode || '').trim()
      && cached?.memberIdentity === String(scope?.memberIdentity || '').trim()
    if (cached?.schemaVersion !== MEMBER_DISPLAY_CACHE_SCHEMA_VERSION || !cached?.updatedAt || !cached?.data || !exactBinding) {
      window.localStorage?.removeItem(key)
      return null
    }
    return cached
  } catch {
    try { window.localStorage?.removeItem(key) } catch { /* storage is optional */ }
    return null
  }
}

/** Atomically replaces the small, non-sensitive display snapshot for one member. */
export function writeMemberDisplayCache(scope, patch) {
  try {
    const key = memberDisplayCacheKey(scope)
    if (!key || typeof window === 'undefined') return null
    const previous = readMemberDisplayCache(scope)?.data || {}
    const value = {
      schemaVersion: MEMBER_DISPLAY_CACHE_SCHEMA_VERSION,
      updatedAt: Date.now(),
      clubCode: String(scope.clubCode).trim(),
      memberIdentity: String(scope.memberIdentity).trim(),
      data: { ...previous, ...patch },
    }
    window.localStorage?.setItem(key, JSON.stringify(value))
    return value
  } catch {
    return null
  }
}

export function clearMemberDisplayCache(scope = {}) {
  try {
    if (typeof window === 'undefined') return false
    const exactKey = memberDisplayCacheKey(scope)
    if (exactKey) {
      window.localStorage?.removeItem(exactKey)
      return true
    }
    const clubMarker = scope.clubCode ? `:${segment(scope.clubCode)}:` : null
    for (let index = window.localStorage.length - 1; index >= 0; index -= 1) {
      const key = window.localStorage.key(index)
      if (key?.startsWith(`${MEMBER_DISPLAY_CACHE_PREFIX}:`) && (!clubMarker || key.includes(clubMarker))) {
        window.localStorage.removeItem(key)
      }
    }
    return true
  } catch {
    return false
  }
}

const CLUB_CACHE_PREFIX = `privana_members_club_v${MEMBER_DISPLAY_CACHE_SCHEMA_VERSION}:`

export function readClubDisplayCache(clubCode) {
  try {
    if (!clubCode || typeof window === 'undefined') return null
    const value = JSON.parse(window.localStorage?.getItem(`${CLUB_CACHE_PREFIX}${segment(clubCode)}`) || 'null')
    return value?.schemaVersion === MEMBER_DISPLAY_CACHE_SCHEMA_VERSION ? value.data : null
  } catch { return null }
}

export function writeClubDisplayCache(clubCode, data) {
  try {
    if (!clubCode || typeof window === 'undefined') return null
    const previous = readClubDisplayCache(clubCode) || {}
    window.localStorage?.setItem(`${CLUB_CACHE_PREFIX}${segment(clubCode)}`, JSON.stringify({
      schemaVersion: MEMBER_DISPLAY_CACHE_SCHEMA_VERSION,
      updatedAt: Date.now(),
      data: { ...previous, ...data },
    }))
    return true
  } catch { return null }
}

export function clearClubDisplayCache(clubCode) {
  try {
    if (typeof window === 'undefined' || !clubCode) return false
    window.localStorage?.removeItem(`${CLUB_CACHE_PREFIX}${segment(clubCode)}`)
    return true
  } catch { return false }
}
